import { c as _c } from "react/compiler-runtime";
import { useAtom } from "jotai";
import { selectedNFTsAtom, bulkTransferModalAtom, mantraListingsModalAtom, type SelectedNFT } from "@/config/atoms/portfolio/selectedNFTs";
import type { Address } from "viem";
export const useSelectedNFTs = () => {
  const $ = _c(36);
  const [selectedNFTs, setSelectedNFTs] = useAtom(selectedNFTsAtom);
  const [bulkTransferModalOpen, setBulkTransferModalOpen] = useAtom(bulkTransferModalAtom);
  const [mantraListingsModal, setMantraListingsModal] = useAtom(mantraListingsModalAtom);
  let t0;
  if ($[0] !== setSelectedNFTs) {
    t0 = nft => {
      setSelectedNFTs(prev => {
        const exists = prev.find(item => item.id === nft.id);
        if (exists) {
          return prev;
        }
        return [...prev, nft];
      });
    };
    $[0] = setSelectedNFTs;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const addNFT = t0;
  let t1;
  if ($[2] !== setSelectedNFTs) {
    t1 = nftId => {
      setSelectedNFTs(prev_0 => prev_0.filter(item_0 => item_0.id !== nftId));
    };
    $[2] = setSelectedNFTs;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const removeNFT = t1;
  let t2;
  if ($[4] !== setSelectedNFTs) {
    t2 = nftIds => {
      setSelectedNFTs(prev_1 => prev_1.filter(item_1 => !nftIds.includes(item_1.id)));
    };
    $[4] = setSelectedNFTs;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const removeNFTs = t2;
  let t3;
  if ($[6] !== addNFT || $[7] !== removeNFT || $[8] !== selectedNFTs) {
    t3 = nft_0 => {
      const exists_0 = selectedNFTs.find(item_2 => item_2.id === nft_0.id);
      if (exists_0) {
        removeNFT(nft_0.id);
      } else {
        addNFT(nft_0);
      }
    };
    $[6] = addNFT;
    $[7] = removeNFT;
    $[8] = selectedNFTs;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const toggleNFT = t3;
  let t4;
  if ($[10] !== setSelectedNFTs) {
    t4 = () => {
      setSelectedNFTs([]);
    };
    $[10] = setSelectedNFTs;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const clearSelection = t4;
  let t5;
  if ($[12] !== selectedNFTs) {
    t5 = nftId_0 => selectedNFTs.some(item_3 => item_3.id === nftId_0);
    $[12] = selectedNFTs;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const isSelected = t5;
  let t6;
  if ($[14] !== setBulkTransferModalOpen) {
    t6 = () => {
      setBulkTransferModalOpen(true);
    };
    $[14] = setBulkTransferModalOpen;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const openBulkTransferModal = t6;
  let t7;
  if ($[16] !== setBulkTransferModalOpen) {
    t7 = () => {
      setBulkTransferModalOpen(false);
    };
    $[16] = setBulkTransferModalOpen;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const closeBulkTransferModal = t7;
  let t8;
  if ($[18] !== setMantraListingsModal) {
    t8 = collectionAddress => {
      setMantraListingsModal({
        isOpen: true,
        collectionAddress
      });
    };
    $[18] = setMantraListingsModal;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const openMantraListingsModal = t8;
  let t9;
  if ($[20] !== setMantraListingsModal) {
    t9 = () => {
      setMantraListingsModal({
        isOpen: false,
        collectionAddress: undefined
      });
    };
    $[20] = setMantraListingsModal;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const closeMantraListingsModal = t9;
  let t10;
  if ($[22] !== addNFT || $[23] !== bulkTransferModalOpen || $[24] !== clearSelection || $[25] !== closeBulkTransferModal || $[26] !== closeMantraListingsModal || $[27] !== isSelected || $[28] !== mantraListingsModal || $[29] !== openBulkTransferModal || $[30] !== openMantraListingsModal || $[31] !== removeNFT || $[32] !== removeNFTs || $[33] !== selectedNFTs || $[34] !== toggleNFT) {
    t10 = {
      selectedNFTs,
      selectedCount: selectedNFTs.length,
      addNFT,
      removeNFT,
      removeNFTs,
      toggleNFT,
      clearSelection,
      isSelected,
      bulkTransferModalOpen,
      openBulkTransferModal,
      closeBulkTransferModal,
      mantraListingsModal,
      openMantraListingsModal,
      closeMantraListingsModal
    };
    $[22] = addNFT;
    $[23] = bulkTransferModalOpen;
    $[24] = clearSelection;
    $[25] = closeBulkTransferModal;
    $[26] = closeMantraListingsModal;
    $[27] = isSelected;
    $[28] = mantraListingsModal;
    $[29] = openBulkTransferModal;
    $[30] = openMantraListingsModal;
    $[31] = removeNFT;
    $[32] = removeNFTs;
    $[33] = selectedNFTs;
    $[34] = toggleNFT;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  return t10;
};